import React from 'react';
import { Lock, Unlock } from 'lucide-react';
import { StatusBadge } from '../UI/StatusBadge';

/**
 * Lock state for one payroll record, readable without a hover.
 *
 * The pill shows the current state (Locked / Unlocked) with a closed or
 * open padlock. Clicking a locked record asks to unlock it; clicking an
 * unlocked record locks it. The tooltip names that click action.
 *
 * @param {boolean} isFinalized
 * @param {boolean} [disabled]
 * @param {() => void} onLock
 * @param {() => void} onUnlock
 */
const PayrollLockButton = ({ isFinalized, disabled = false, onLock, onUnlock }) => {
  const locked = Boolean(isFinalized);
  const hint = locked
    ? 'Locked. Click to unlock this payroll.'
    : 'Unlocked. Click to lock this payroll.';

  return (
    <button
      type="button"
      onClick={locked ? onUnlock : onLock}
      disabled={disabled}
      title={hint}
      aria-label={hint}
      className="inline-flex rounded-full hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <StatusBadge
        status={locked ? 'payroll_locked' : 'payroll_unlocked'}
        icon={locked ? Lock : Unlock}
        title={hint}
      />
    </button>
  );
};

export default PayrollLockButton;
